// extracted by mini-css-extract-plugin
export var numpadContainer = "_mz-1";
export var phoneButton = "_mz-0";